import { render } from "./menu.vue?vue&type=template&id=1d4fe1e9&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=1d4fe1e9&lang=scss&scoped=true"
import "./menu.vue?vue&type=style&index=1&id=1d4fe1e9&lang=scss"
script.render = render
script.__scopeId = "data-v-1d4fe1e9"

export default script